/* src/app/common/components/item-price-selecion/item-price-selecion.component.scss */
ion-datetime {
  --padding-end: 16px;
}
.errors {
  --color: var(--ion-color-base);
}
.modal-header {
  --background: var(--ion-color-primary);
  --color: #fff;
}
.modal-header ion-title {
  color: white;
  font-weight: 600;
}
.modal-header ion-button {
  color: white;
}
.smartdine-form {
  padding: 12px;
}
.smartdine-form ion-item {
  --background: #fbfefc;
  border-radius: 8px;
  margin-bottom: 8px;
  --inner-padding-end: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.smartdine-form ion-item ion-label {
  min-width: 180px;
  font-weight: 600;
  color: var(--ion-color-primary);
  font-size: 14px;
}
.smartdine-form ion-item ion-label.stock-toggle-label {
  font-size: 14px;
  color: var(--ion-color-primary);
  flex: 1;
  white-space: normal;
}
.smartdine-form ion-item ion-input,
.smartdine-form ion-item ion-select {
  text-align: right;
}
.smartdine-form .required-star {
  color: var(--ion-color-danger);
  margin-left: 4px;
}
.smartdine-form small.error-text {
  color: var(--ion-color-danger);
  display: block;
  text-align: right;
  font-size: 12px;
  padding: 2px 4px 6px;
}
.price-history-list {
  margin-top: 1rem;
}
.price-history-list .price-history-header {
  --background: transparent;
}
.price-history-list .price-history-header h3 {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  color: var(--ion-color-title);
}
.price-history-list ion-item {
  --background: #f1f1f2;
}
.price-history-list ion-item.striped-row {
  --background: #f9f9f9;
}
.price-history-list .price-history-label {
  width: 100%;
  padding: 0;
  margin: 0;
}
.price-history-list .price-history-label .row-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.price-history-list .price-history-label .date-range {
  font-size: 14px;
  color: var(--ion-color-dark);
}
.price-history-list .price-history-label .price {
  font-size: 15px;
  font-weight: 600;
  color: var(--ion-color-primary);
  white-space: nowrap;
}
/*# sourceMappingURL=item-price-selecion.component.css.map */
